import * as React from "react";
import { action, observable } from "mobx";
import { hashHistory } from "react-router";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization } from "../../../models/localization";
import { Auth } from "../../../utils/auth";
import { ScreenMode } from "../../../models/enums";
import PasswordResetDlg from "../passwordReset";
import { Row, Col, Grid } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, withMobileDialog } from "material-ui/Dialog";
import Visibility from "material-ui-icons/Visibility";
import VisibilityOff from "material-ui-icons/VisibilityOff";
import IconButton from "material-ui/IconButton";
import Input, { InputLabel, InputAdornment } from "material-ui/Input";
import Checkbox from "material-ui/Checkbox";
import { FormControl, FormHelperText, FormGroup, FormControlLabel } from 'material-ui/Form';
import * as s from "./login.css";
import { ValidatorForm } from "react-form-validator-core";
import { TextValidator } from "react-material-ui-form-validator";
import MenuIcon from "material-ui-icons/Menu";
import * as FontAwesome from "react-fontawesome";

const styles: any = {
  MuiIconButton: {
    color: "#5B6770",
  },
  container: {
    padding: "0",
  },
}

const stylesBtn: any = ({
  root: {
    backgroundColor: "white",
    color: "black",
    marginRight: "10px",
  },
});

//TODO: Remove border from MuiPaper-rounded-9 --> causing white line to appear under blue login section

@observer
export default class LoginDlg extends React.Component<{ store: SeekerStore }, {}> {
  @observable username: string;
  @observable pwd: string;
  @observable errMsg: boolean;
  @observable showPassword: boolean;
  @observable submitted: boolean;

  constructor(props: any) {
    super(props);
    this.username = "";
    this.pwd = "";
    this.showPassword = false;
    this.submitted = false;
    this.errMsg = false;
  }

  @action handleSubmit = (): void => {
    this.submitted = true, () => {
      setTimeout(() => this.submitted = false, 5000);
    }
    Auth.login(this.username, this.pwd, this.updateViewstate);
  }

  @action handleInputChange = (event: { target: HTMLInputElement; }): void => {
    this[event.target.name] = event.target.value;
    if (event.target.name === "username") {
      this.username = event.target.value.trim();
    }
  }

  @action closeDialog = (): void => {
    this.username = this.pwd = "";
    this.showPassword = false;
    this.errMsg = false;
    this.props.store.viewState.closeLogin();
  }

  @action updateViewstate = (success: boolean, acceptTerms: number): void => {
    if (success) {
      this.props.store.legal.setAcceptTerms(acceptTerms);
      this.props.store.profileStore.loadProfile();
      this.props.store.viewState.returnToLastView();
      this.closeDialog();
    } else {
      this.errMsg = true;
    }
  }

  @action togglePassword = (): void => {
    this.showPassword = !this.showPassword;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const imgUrl: string = local.login.loginLogo || "images/ss_logo_RGB_knockout.png"
    const fontAwesomeStyle: any = { marginRight: "4px" };
    const color: string = local.login.customColor || "#0072CE";
    const customColorOne: any = {
      backgroundColor: color,
      padding: "70px 20px 50px 20px",
    }
    const customColorThree: any = {
      backgroundColor: color,
      padding: "0px 20px 0px 10px",
      height: "100%",
    }

    return <div>
      <Dialog open={this.props.store.viewState.showLogin}
        onClose={() => this.closeDialog} aria-labelledby="responsive-dialog-title" fullScreen={mode === ScreenMode.Mobile}  >
        <DialogContent style={styles.container} >
          <Grid className={s.gridContainer}>
            <Row className={s.rowMargin}>           
              <Col xs={12} sm={6}>
                <div style={customColorOne}>
                  <img src={imgUrl} width="90%" height="auto" className={s.loginLogo} alt={local.login.loginLogoAlt} onClick={() => hashHistory.push("/home")} />
                </div>
                </Col>             
              <Col xs={12} sm={6} className={s.containerTwo}>
                <h3>{local.login.returningUser}</h3>
              </Col>              
            </Row>
            <Row className={s.rowMargin}>
              <Col xs={12} sm={6} last="xs" first="sm">
                <div style={customColorThree}>
                <div className={s.ssLoginLinks}>
                  <h6>{local.login.registerQuestion}</h6>
                  <p onClick={() => this.props.store.viewState.setShowRegister(true)} ><FontAwesome name="user-plus" className="fa-1x" style={fontAwesomeStyle} ></FontAwesome> {local.login.registerClickThrough}</p>
                  <h6>{local.login.emailQuestion}</h6>
                  <p onClick={() => this.props.store.viewState.showLink("https://myaccount.google.com/")} ><FontAwesome name="envelope" className="fa-1x" style={fontAwesomeStyle} ></FontAwesome> {local.login.emailClickThrough}</p>
                </div>
                </div>
              </Col>               
              <Col xs={12} sm={6} first="xs" className={s.containerFour} >
                <ValidatorForm
                  ref="form"
                  instantValidate={false}
                  onSubmit={this.handleSubmit}>
                  <div>
                    <FormControl style={styles.formControl}>
                      <TextValidator
                        label={local.login.enterEmail}
                        inputProps={{
                          autoCapitalize: 'none',
                        }}
                        name="username"
                        id="username"
                        type="text"
                        autoComplete="current-username"
                        validators={['required', 'isEmail']}
                        errorMessages={[local.validation.requiredField, local.validation.invalidEmail]}
                        value={this.username}
                        onChange={this.handleInputChange} />
                      <br /><br /><br />
                      <TextValidator
                        label={local.login.enterPassword}
                        name="pwd"
                        id="pwd"
                        autoComplete="current-password"
                        type={this.showPassword ? "text" : "password"}
                        validators={['required']}
                        errorMessages={[local.validation.requiredField]}
                        value={this.pwd}
                        onChange={this.handleInputChange}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton style={styles.MuiIconButton}
                                onClick={this.togglePassword}
                                onMouseDown={() => (e) => event.preventDefault()}>
                                {this.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }} />
                    </FormControl>
                  </div>
                  <br />
                  <p className={s.forgotPasswordText} onClick={() => this.props.store.viewState.setShowPasswordReset(true)} >{local.login.forgotPwdMsg}</p>
                  {this.errMsg ? <p className={s.errorText}>{local.login.loginErrMsg}</p> : null}
                  <br />
                  <DialogActions>
                    <Button raised style={stylesBtn.root} onClick={() => this.closeDialog()} color="primary">{local.cancel}</Button>
                    <Button raised style={stylesBtn.root} color="primary" type="submit">{local.login.login}</Button>
                  </DialogActions>
                </ValidatorForm>
              </Col>
            </Row>
          </Grid>
        </DialogContent>
      </Dialog>
      <PasswordResetDlg store={this.props.store} />
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/dialogs/login/index.tsx